export default __webpack_public_path__ + "static/media/activeuserpic.df13f694.svg";